var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIssueGrade = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 12,
  fill: "#FFFFFF1A"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 1
  },
  transform: "translate(10 9)",
  d: "M9.02 7.477a.563.563 0 0 1-.243.457c-2.05 1.406-3.394 3.722-3.41 6.398 0 .45 0 .91.008 1.379 0 .012.004.023.008.031a.093.093 0 0 0 .05.059c.422.18.88.3 1.352.351 2.059.223 4.172.446 6.324.524.301.012.551-.23.551-.531v-.157c0-.738.602-1.34 1.34-1.34.738 0 1.34.602 1.34 1.34v.14c0 .302.25.548.555.532 2.015-.09 3.992-.297 5.918-.508a4.627 4.627 0 0 0 1.519-.425.502.502 0 0 0 .281-.47 38.458 38.458 0 0 0-.058-1.382c-.137-2.477-1.426-4.578-3.332-5.895a.556.556 0 0 1-.243-.453v-.996c0-3.3-2.68-5.98-5.98-5.98-3.3 0-5.98 2.68-5.98 5.98ZM15 3.766a2.766 2.766 0 0 0-2.766 2.765c0 .028.028.051.055.047.152-.02.305-.035.457-.05.809-.067 1.531-.11 2.05-.11.614 0 1.497.059 2.47.144l.406.047a.08.08 0 0 0 .094-.078A2.766 2.766 0 0 0 15 3.766Zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    fill: "#fff",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(10 9)",
  d: "M13.18 19.36c.265.011.48.23.48.495 0 .739.602 1.34 1.34 1.34.738 0 1.34-.601 1.34-1.34 0-.273.219-.5.492-.511 2.184-.094 4.293-.313 6.27-.528.246-.027.488-.066.726-.113.367-.078.73.2.703.574-.234 3.227-.93 6.535-2.504 9.11a.517.517 0 0 1-.379.246c-2.304.289-4.785.515-6.847.512-2.04-.008-4.492-.247-6.762-.543a.515.515 0 0 1-.414-.313c-1.172-2.742-1.773-5.894-2.05-8.91-.036-.363.304-.645.663-.594.086.012.176.024.262.031 2.098.227 4.352.465 6.68.543ZM27.309 16.61c0-.364.351-.622.668-.442a3.4 3.4 0 0 1 1.707 2.621c.093.953.18 1.973.18 3.023 0 .946-.106 2.375-.2 3.461a3.215 3.215 0 0 1-2.652 2.899l-.98.164c-.43.07-.759-.371-.595-.773 1.465-3.508 1.86-7.543 1.872-10.954ZM4.5 27.605c.133.391-.195.793-.602.723-.328-.055-.636-.105-.91-.156a3.215 3.215 0 0 1-2.652-2.895c-.094-1.086-.2-2.515-.2-3.465 0-1.05.087-2.07.18-3.023a3.394 3.394 0 0 1 1.735-2.637c.308-.172.656.075.668.43.113 3.398.554 7.383 1.781 11.023Zm0 0"
})));
export default SvgIssueGrade;